import { render, staticRenderFns } from "./Anquan.vue?vue&type=template&id=593bb63c&scoped=true&"
import script from "./Anquan.vue?vue&type=script&lang=js&"
export * from "./Anquan.vue?vue&type=script&lang=js&"
import style0 from "./Anquan.vue?vue&type=style&index=0&id=593bb63c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593bb63c",
  null
  
)

export default component.exports